const ScanGlitchShader = {

	name: 'ScanGlitchShader',

	uniforms: {

		'tDiffuse': { value: null },
		'opacity': { value: 1.0 },
		'time': { type: 'f', value: 0.002}

	},

	vertexShader: /* glsl */`

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,

	fragmentShader: /* glsl */`

		uniform float opacity;

		uniform sampler2D tDiffuse;

		uniform float time;

		varying vec2 vUv;

        vec2 uv;

		float rand(vec2 co){
			return fract(sin(dot(co, vec2(12.9898, 78.233))) * 43758.5453);
		}

          void texelCoord()
        {
          uv = vec2(vUv.x + (rand(vec2(vUv.y / 150000.0  + (time / 10000000.0), 1.0))) / 155.0, vUv.y);
          uv = vec2(uv.x + (rand(vec2(uv.y / 900000.0  + (time / 10000000.0), 1.0))) / 111.0, uv.y);
        }

		void main() {

			texelCoord();
			vec4 texel = texture2D( tDiffuse, vec2(uv.x, uv.y) );
   
			gl_FragColor = texel * opacity;
   ;
		}`

};

